import { isBorderStyleToken, isBorderToken, isBorderWidthToken } from '@smoothie-framework/ui-core/tokens';
import { isCssColorKeyword } from './color-values';
import { isCssWideKeyword } from './css-wide-keywords';
import { containsTokenReferenceSyntax, isBareUtilityIdentifier, isNumericUtilityLiteral, } from './utility-value-syntax';
const BORDER_SHORTHAND_KEYWORD_SET = new Set([
    'none',
    'hidden',
    'dotted',
    'dashed',
    'solid',
    'double',
    'groove',
    'ridge',
    'inset',
    'outset',
    'thin',
    'medium',
    'thick',
]);
const BORDER_WIDTH_KEYWORD_SET = new Set(['thin', 'medium', 'thick']);
const BORDER_STYLE_KEYWORD_SET = new Set([
    'none',
    'hidden',
    'dotted',
    'dashed',
    'solid',
    'double',
    'groove',
    'ridge',
    'inset',
    'outset',
]);
export function classifyBorderUtilityValue(rawValue) {
    if (rawValue === undefined || rawValue === null) {
        return { valid: false, reason: 'empty' };
    }
    if (typeof rawValue !== 'string') {
        return { valid: false, reason: 'invalid_type' };
    }
    const normalizedValue = rawValue.trim();
    if (normalizedValue.length === 0) {
        return { valid: false, reason: 'empty' };
    }
    if (containsTokenReferenceSyntax(normalizedValue)) {
        return { valid: false, reason: 'token_reference', normalizedValue };
    }
    if (isNumericUtilityLiteral(normalizedValue)) {
        return { valid: false, reason: 'invalid_type', normalizedValue };
    }
    if (isBorderToken(normalizedValue)) {
        return { valid: true, kind: 'token', normalizedValue };
    }
    if (isBareUtilityIdentifier(normalizedValue)) {
        if (isCssWideKeyword(normalizedValue)
            || BORDER_SHORTHAND_KEYWORD_SET.has(normalizedValue)
            || isCssColorKeyword(normalizedValue)) {
            return { valid: true, kind: 'keyword', normalizedValue };
        }
        return { valid: false, reason: 'unsupported_bare_identifier', normalizedValue };
    }
    return { valid: true, kind: 'arbitrary', normalizedValue };
}
function classifyNumericBorderWidthValue(normalizedValue) {
    const numericValue = Number(normalizedValue);
    if (!Number.isFinite(numericValue)) {
        return { valid: false, reason: 'invalid_type', normalizedValue };
    }
    if (numericValue < 0) {
        return { valid: false, reason: 'negative_not_allowed', normalizedValue };
    }
    return { valid: true, kind: 'numeric', normalizedValue };
}
export function classifyBorderWidthUtilityValue(rawValue) {
    if (rawValue === undefined || rawValue === null) {
        return { valid: false, reason: 'empty' };
    }
    if (typeof rawValue === 'number') {
        const normalizedValue = String(rawValue);
        return isNumericUtilityLiteral(normalizedValue)
            ? classifyNumericBorderWidthValue(normalizedValue)
            : { valid: false, reason: 'invalid_type', normalizedValue };
    }
    if (typeof rawValue !== 'string') {
        return { valid: false, reason: 'invalid_type' };
    }
    const normalizedValue = rawValue.trim();
    if (normalizedValue.length === 0) {
        return { valid: false, reason: 'empty' };
    }
    if (containsTokenReferenceSyntax(normalizedValue)) {
        return { valid: false, reason: 'token_reference', normalizedValue };
    }
    if (isNumericUtilityLiteral(normalizedValue)) {
        return classifyNumericBorderWidthValue(normalizedValue);
    }
    if (isBorderWidthToken(normalizedValue)) {
        return { valid: true, kind: 'token', normalizedValue };
    }
    if (isBareUtilityIdentifier(normalizedValue)) {
        if (isCssWideKeyword(normalizedValue) || BORDER_WIDTH_KEYWORD_SET.has(normalizedValue)) {
            return { valid: true, kind: 'keyword', normalizedValue };
        }
        return { valid: false, reason: 'unsupported_bare_identifier', normalizedValue };
    }
    return { valid: true, kind: 'arbitrary', normalizedValue };
}
export function classifyBorderStyleUtilityValue(rawValue) {
    if (rawValue === undefined || rawValue === null) {
        return { valid: false, reason: 'empty' };
    }
    if (typeof rawValue !== 'string') {
        return { valid: false, reason: 'invalid_type' };
    }
    const normalizedValue = rawValue.trim();
    if (normalizedValue.length === 0) {
        return { valid: false, reason: 'empty' };
    }
    if (containsTokenReferenceSyntax(normalizedValue)) {
        return { valid: false, reason: 'token_reference', normalizedValue };
    }
    if (isNumericUtilityLiteral(normalizedValue)) {
        return { valid: false, reason: 'invalid_type', normalizedValue };
    }
    if (isBorderStyleToken(normalizedValue)) {
        return { valid: true, kind: 'token', normalizedValue };
    }
    if (isBareUtilityIdentifier(normalizedValue)) {
        if (isCssWideKeyword(normalizedValue) || BORDER_STYLE_KEYWORD_SET.has(normalizedValue)) {
            return { valid: true, kind: 'keyword', normalizedValue };
        }
        return { valid: false, reason: 'unsupported_bare_identifier', normalizedValue };
    }
    return { valid: true, kind: 'arbitrary', normalizedValue };
}
//# sourceMappingURL=border-values.js.map